if (!customElements.get('loyalty-lion-amount')) {
  customElements.define(
    'loyalty-lion-amount',
    // eslint-disable-next-line no-undef
    class LoyaltyLionAmount extends window.BAO.CustomElement() {
      connectedCallback () {
        super.connectedCallback()

        const observerConfig = {
          childList: true,
          subtree: true,
        }

        const mutationObserver = new MutationObserver(
          this.handleMutation.bind(this),
        )

        mutationObserver.observe(this, observerConfig)
      }

      handleMutation (mutationsList, observer) {
        mutationsList.forEach(mutation => {
          if (mutation.type === 'childList') {
            const lionPointsElement = this.querySelector(
              '[data-loyalty-lion-amount-el="points"]',
            )

            if (!lionPointsElement) return

            if (lionPointsElement.dataset.lionPointsFor === '0') {
              const parent = lionPointsElement.closest('.drw-Footer_Rewards')

              if (parent) {
                parent.style.display = 'none'
              }

              observer.disconnect()
            }

            if (lionPointsElement.textContent !== '') {
              try {
                const points = this.els.points.element.textContent.replace(
                  ',',
                  '',
                )
                const price = window.BAO.utils.formatMoney(points)
                this.els.injection.element.textContent = `${price}`
                observer.disconnect()
              } catch (error) {
                console.error(error)
                this.style.display = 'none'
              }
            }
          }
        })
      }
    },
  )
}
